import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common.service';

const API_URL = CommonServices.getApiUrl() + 'mcp_key';

class McpKeyService {

  list() {
    return axios.get(API_URL, { headers: authHeader() });
  }

  connection() {
    return axios.get(API_URL + '/connection', { headers: authHeader() });
  }

  generate(label) {
    return axios.post(API_URL, { label }, { headers: authHeader() });
  }

  reveal(id) {
    return axios.get(API_URL + '/' + id + '/reveal', { headers: authHeader() });
  }

  remove(id) {
    return axios.delete(API_URL + '/' + id, { headers: authHeader() });
  }
}

export default new McpKeyService();
